module.exports = __webpack_public_path__ + "img/1465063259.ec58b788.jpg";